export const env = {
  stripePublishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
}

console.log({ env })
